import PropTypes from 'prop-types';
import { values } from 'ramda';

import { Image } from '../schema/prismic/fields/image';
import { Filters } from './document';
import { REGION, THEMATIC } from './filters';
import { LinkDocument, LinkMedia } from './link';
import { Meta, Page } from './page/page';

export const MEDIA_TYPE = {
  AUDIO: 'audio',
  COMMUNICATION: 'communication',
  INFOGRAPHIC: 'infographic',
  PHOTO: 'photo',
  PUBLICATION: 'publication',
  RELEASE: 'release',
  VIDEO: 'video',
};

export type MediaPress = Page & {
  description: string;
  publication: string;
  mediaType: string;
  thematic: THEMATIC;
  localization: REGION;
  image: Image;
  link: LinkMedia;
  downloadUrl: string;
  related_article: LinkDocument;
  onNewsroom: boolean;
  filters: Filters;
  date?: number;
  onFinance?: boolean;
  relatedDate?: number;
  transcription?: string;
  classCategory?: string;
  onHome: boolean;
  meta: Meta;
};

export const MediaType = PropTypes.oneOf(values(MEDIA_TYPE));
